import { render, staticRenderFns } from "./ReceiptSettings.vue?vue&type=template&id=002a3178&"
import script from "./ReceiptSettings.vue?vue&type=script&lang=js&"
export * from "./ReceiptSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports